<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Histori RO</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-credit-card-sync</v-icon>
			<div class="pl-2">Repeat Order</div>
			<div class="px-2">/</div>
			<div>Histori RO</div>
		</div>
		<div class="mt-5">
			<v-row justify="end">
				<v-col cols="12" sm="11" md="8" class="py-0 py-sm-3">
					<v-row justify="end">
						<v-col cols="12" sm="4" md="4" xl="3">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Pilih Bulan" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-lg date-no-border" hide-details :value="convertMonth(dateStart)"></v-text-field>
								</template>
								<v-date-picker locale="id" type="month" first-day-of-week="0" color="primary" :max="today" @input="startDate = false" @change="getData" v-model="dateStart"></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="!loading">
				<v-row class="ml-0" v-if="listHistoryRO.length > 0">
					<v-col cols="12" sm="4" md="3" class="pl-0 pb-0" v-for="ro in listHistoryRO" :key="ro.sales_personal_id">
						<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
							<v-row>
								<v-col cols="12" sm="12" md="12" class="pb-0">
									<div class="font-size-10 cl-grey">Serial</div>
									<div class="font-size-13 font-size-xs-11 cl-primary font-weight-500">{{ ro.serial_log_serial_id }}</div>
								</v-col>
								<v-col cols="12" sm="12" md="12" class="pt-3 my-auto">
									<div class="font-size-10 cl-grey">Tanggal RO</div>
									<div class="font-size-10 cl-grey font-weight-500">{{ ro.serial_log_serial_used_datetime | haritanggaljam }}</div>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listHistoryRO.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada histori repeat order yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div class="mt-5" v-if="listHistoryRO.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historyROPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ historyROPagination.total_display }} data dari total {{ historyROPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			startDate: false,
			dateStart: moment().format("YYYY-MM"),
			start: '',
			end: '',
			monthYear: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
			dayStart: '1',
			dayEnd: '31',
			page: 1,
			limit: '12',
			listLimit: [ '12', '20', '50', '100' ],
		}
	},
	computed: {
		...mapState('repeatOrder', ['listHistoryRO', 'historyROPagination']),
	},
	methods: {
		...mapActions('repeatOrder', ['getHistoryRO']),

		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getData() {
			this.loading = true
			let params = {limit:this.limit, page: this.page}
			if (this.dateStart) {
				this.start = this.dateStart + '-' + this.dayStart
				this.end = this.dateStart + '-' + this.dayEnd
				params.start = this.start
				params.end = this.end
			} else {
				this.start = this.monthYear + '-' + this.dayStart
				this.end = this.monthYear + '-' + this.dayEnd
				params.start = this.start
				params.end = this.end
			}
			this.getHistoryRO(params).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Histori RO`)
		this.getData()
	}
};
</script>

